export const SESSION_STORAGE_EXTERNAL_ID_KEY = 'EXTERNAL_ID_KEY'
export const REDIRECT_EXTERNAL_ID_KEY = 'REDIRECT_EXTERNAL_ID_KEY'
export const SESSION_STORAGE_ORIGIN_KEY = 'ORIGIN_KEY'

interface RedirectExternalIdStorage {
  SESSION_STORAGE_ORIGIN_KEY: string
  SESSION_STORAGE_EXTERNAL_ID_KEY: string
}
interface RedirectExternalIdStorageParams {
  origin: string | null
  externalId?: string
}

export const setRedirectExternalIdStorage = ({
  origin,
  externalId,
}: RedirectExternalIdStorageParams) => {
  if (!externalId) {
    return
  }
  sessionStorage.setItem(
    REDIRECT_EXTERNAL_ID_KEY,
    JSON.stringify({
      SESSION_STORAGE_ORIGIN_KEY: String(origin),
      SESSION_STORAGE_EXTERNAL_ID_KEY: String(externalId),
    }),
  )
}

export const getRedirectExternalIdStorage = (): RedirectExternalIdStorage | null => {
  const redirectExternalIdValue = sessionStorage.getItem(REDIRECT_EXTERNAL_ID_KEY)
  try {
    return redirectExternalIdValue ? JSON.parse(redirectExternalIdValue) : null
  } catch (e) {
    return null
  }
}

export const removeRedirectExternalIdStorage = () => {
  sessionStorage.removeItem(REDIRECT_EXTERNAL_ID_KEY)
}
